import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { LOGOUT } from '~/store/mutationTypes';

// Exported for the code running outside components (router guards, Apollo, Sentry)
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

// The sign-out clears the whole localStorage before LOGOUT. vuex-persistedstate wrote the
// persisted state back on that commit (as on every commit): keep doing so.
const persistedStores = new Map();
pinia.use(({ store, options }) => {
  if (options.persist) {
    persistedStores.set(store.$id, store);
  }
  if (store.$id === 'auth') {
    store.$onAction(({ name, after }) => {
      if (name === LOGOUT) {
        after(() => persistedStores.forEach((persistedStore) => persistedStore.$persist()));
      }
    });
  }
});

export default pinia;
